export const ALLOWED_ORDER_TASKS = [
  'llc_formation',
  'corp_formation',
  'ein_creation',
  'business_license_report',
  'zb_banking_preferred',
  'llc_annual_report',
  'corp_annual_report',
  'llc_amendment',
  'corp_amendment',
  'change_of_registered_agent',
  'ny_publication'
];

// this order task type to entitlement
// mapping comes from https://github.com/zenbusiness/entitlements-api/blob/main/server/api/businesses/constants.js

export const EIN_UPSELL = {
  title: 'dashboard.orderTracker.upsell.ein',
  url: '/dashboard/{BUUID}/products/ein-creation',
  entitlement: 'ein_creation'
};

export const BLR_UPSELL = {
  title: 'dashboard.orderTracker.upsell.blr',
  url: '/dashboard/{BUUID}/compliance/business-licenses',
  entitlement: 'business_license_report'
};

export const MONEY_UPSELL = {
  title: 'dashboard.orderTracker.upsell.money',
  url: '/dashboard/{BUUID}/products/money-pro',
  entitlement: 'accounting'
};

export const TAX_ADVISE_UPSELL = {
  title: 'dashboard.orderTracker.upsell.taxAdvise',
  url: '/dashboard/{BUUID}/products/tax-advice',
  entitlement: 'tax_annual_filing'
};

export const TRADEMARKS_SEARCH_UPSELL = {
  title: 'dashboard.orderTracker.upsell.trademarksSearch',
  url: '/dashboard/{BUUID}/products/trademarks-search',
  entitlement: 'trademarks_search'
};

export const WFC_UPSELL = {
  title: 'dashboard.orderTracker.upsell.wfc',
  url: '/dashboard/{BUUID}/products/wfc-services?package=basic',
  entitlement: 'worry_free_service'
};

export const WFC_ADVANCED_UPSELL = {
  title: 'dashboard.orderTracker.upsell.wfcAdvanced',
  url: '/dashboard/{BUUID}/products/wfc-advanced',
  entitlement: 'worry_free_service_advanced'
};

export const NY_PUBLICATION_UPSELL = {
  title: 'dashboard.orderTracker.upsell.nyPublication',
  entitlement: 'ny_publication',
  allowedJurisdictions: ['NY'],
  useSlideSheet: true
};

export const ORDER_TASKS_UPSELLS = {
  llc_formation: [
    EIN_UPSELL,
    NY_PUBLICATION_UPSELL,
    BLR_UPSELL,
    WFC_UPSELL,
    TRADEMARKS_SEARCH_UPSELL
  ],
  corp_formation: [
    EIN_UPSELL,
    NY_PUBLICATION_UPSELL,
    BLR_UPSELL,
    WFC_UPSELL,
    TRADEMARKS_SEARCH_UPSELL
  ],
  ein_creation: [
    NY_PUBLICATION_UPSELL,
    BLR_UPSELL,
    WFC_UPSELL,
    TRADEMARKS_SEARCH_UPSELL
  ],
  business_license_report: [
    WFC_UPSELL,
    TRADEMARKS_SEARCH_UPSELL
  ],
  beneficial_ownership_filing: [
    BLR_UPSELL
  ],
  zb_banking_preferred: [
    MONEY_UPSELL,
    TAX_ADVISE_UPSELL
  ],
  ny_publication: [
    BLR_UPSELL
  ]
};

export const SKIPPABLE_STATUSES = ['complete', 'active', 'declined', 'cancelled'];

export const CHIP_COLORS = {
  action_req: 'warning',
  incomplete: 'warning',
  pending: 'primary',
  processing: 'info'
};

export const SERVICE_EVENT_PROPERTIES = Object.freeze({
  beneficial_ownership_filing: {
    elementValue: 'beneficial_ownership_filing',
    elementText: 'Beneficial Ownership Filing'
  },
  business_license_report: {
    elementValue: 'business_license_report',
    elementText: 'Business License Report'
  },
  change_of_registered_agent: {
    elementValue: 'change_of_registered_agent',
    elementText: 'Change of Registered Agent'
  },
  corp_amendment: {
    elementValue: 'corp_amendment',
    elementText: 'Corp Amendment'
  },
  corp_annual_report: {
    elementValue: 'corp_annual_report',
    elementText: 'Corp Annual Report'
  },
  corp_formation: {
    elementValue: 'corp_formation',
    elementText: 'Corp Formation'
  },
  ein_creation: {
    elementValue: 'ein_creation',
    elementText: 'EIN Creation'
  },
  llc_amendment: {
    elementValue: 'llc_amendment',
    elementText: 'LLC Amendment'
  },
  llc_annual_report: {
    elementValue: 'llc_annual_report',
    elementText: 'LLC Annual Report'
  },
  llc_formation: {
    elementValue: 'llc_formation',
    elementText: 'LLC Formation'
  },
  zb_banking_preferred: {
    elementValue: 'zb_banking_preferred',
    elementText: 'ZB Banking Preferred'
  },
  ny_publication: {
    elementValue: 'ny_publication',
    elementText: 'NY Publication'
  }
});
